/**
 * Image size enum
 */

export enum ImageSize {
	IMAGE_SIZE_SMALLEST = "ImageSize:Smallest",
	IMAGE_SIZE_SMALL = "ImageSize:Small",
	IMAGE_SIZE_MEDIUM = "ImageSize:Medium",
	IMAGE_SIZE_LARGE = "ImageSize:Large",
	IMAGE_SIZE_LARGEST = "ImageSize:Largest",
	IMAGE_SIZE_ICON = "ImageSize:Icon",
	IMAGE_SIZE_ORIGINAL = "ImageSize:Original",
	IMAGE_SIZE_USE_LARGE_IMAGE = "ImageSize:UseLargeImage",
	IMAGE_SIZE_CUSTOM = "ImageSize:Custom",
}